// extracted by mini-css-extract-plugin
module.exports = {"Grid":"Grid_Grid__1He54","Center":"Grid_Center__23Vme","Spread":"Grid_Spread__njLSx"};